import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import Button from "../Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MaskedInput from "react-text-mask";
import EnrollmentTable, { DownloadCSVButton } from "../Enrollments/EnrollmentTable";
import MenuItem from "@material-ui/core/MenuItem";

const Enrollments = ({
  enrollments,
  fetchAddNote,
  fetchEnrollments,
  fetchMoreEnrollments,
  fetchCancelEnrollments,
  resubmitEnrollment,
  fetchUpdateEnrollmentName,
  fetchSendVerification,
  memberID,
  adminUser,
  page,
  limit,
  hasNext,
  total,
}) => {
  const [searchCriteria, setSearchCriteria] = useState({
    member_id: memberID,
  });
  const [disabled, setDisabled] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      await fetchEnrollments(searchCriteria);
    };
    fetchData();
  }, [memberID]);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
        <Grid container style={{ width: "100%" }}>
          <h1 id="page-title">Enrollments</h1>
        </Grid>
        <span style={{ marginLeft: "10px" }}>
          <DownloadCSVButton
            enrollments={enrollments}
          />
        </span>
      </div>
      <br />
      <EnrollmentTable
        isHold={false}
        adminUser={adminUser}
        searchCriteria={searchCriteria}
        enrollments={enrollments}
        fetchAddNote={fetchAddNote}
        fetchEnrollments={fetchEnrollments}
        fetchCancelEnrollments={fetchCancelEnrollments}
        resubmitEnrollment={resubmitEnrollment}
        fetchSendVerification={fetchSendVerification}
        fetchUpdateEnrollmentName={fetchUpdateEnrollmentName}
      />

      {hasNext && (
        <Button
          onClick={async () => {
            setDisabled(true);
            await fetchMoreEnrollments(searchCriteria);
            setDisabled(false);
          }}
          color="primary"
          variant="contained"
          style={{
            marginRight: 20,
            marginTop: 10,
          }}
          disabled={disabled}
        >
          Load More
        </Button>
      )}

      {enrollments.length > 0 && enrollments.length !== total ? (
        <div style={{ float: "right", marginTop: "10px" }}>
          Downloaded {(page + 1) * limit} of {total} enrollments
        </div>
      ) : (
        enrollments.length > 0 && (
          <div style={{ float: "right", marginTop: "10px" }}>
            Downloaded all {total} enrollments
          </div>
        )
      )}
    </div>
  );
};

Enrollments.propTypes = {
  enrollments: PropTypes.array,
  fetchAddNote: PropTypes.func,
  fetchEnrollments: PropTypes.func,
  fetchMoreEnrollments: PropTypes.func,
  fetchCancelEnrollments: PropTypes.func,
  resubmitEnrollment: PropTypes.func,
  fetchUpdateEnrollmentName: PropTypes.func,
  fetchSendVerification: PropTypes.func,
  memberID: PropTypes.string,
  adminUser: PropTypes.object,
  page: PropTypes.number,
  limit: PropTypes.number,
  hasNext: PropTypes.bool,
  total: PropTypes.number,
};

export default Enrollments;
